<template>
  <div>
    <div
      v-show="!isEmpty"
      ref="barChart"
      style="height: 500px;"
    />
    <Empty
      v-show="isEmpty"
      style="border:none"
      tips="图表暂无数据哦～"
    />
  </div>
</template>

<script>
import echarts from 'echarts';
import cloneDeep from 'lodash/cloneDeep';
import { Empty } from '@/components';

export default {
  name: 'BarChart',
  components: {
    Empty,
  },
  props: {
    chartData: {
      type: Object,
      default: null,
    },
    dimension: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      chartOptions: {
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {
          type: 'scroll',
          orient: 'horizontal',
          left: 'left',
          top: 24,
          data: [],
        },
        xAxis: {
          type: 'category',
          data: [],
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: 'value',
        },
        series: [],
      },
      chart: null,
    };
  },
  computed: {
    isEmpty() {
      return !this.chartData || this.chartData.data.list.length < 1;
    },
  },
  watch: {
    chartData: {
      immediate: true,
      handler(info) {
        if (!info) return;
        this.renderChart();
      },
    },
    dimension: {
      immediate: true,
      handler(info) {
        if (!this.chartData) return;
        this.renderChart();
      },
    },
  },
  methods: {
    renderChart() {
      if (this.isEmpty) return;
      let chartData = this.chartData.data.list;
      let options = cloneDeep(this.chartOptions);
      let legends = chartData.map((item) => item.name);
      options.legend.data = legends;
      options.series = chartData.map((item, index) => {
        return {
          type: 'bar',
          name: legends[index],
          data: [item[this.dimension.value]],
        };
      });
      this.$nextTick(() => {
        if (!this.chart) {
          this.chart = echarts.init(this.$refs['barChart']);
        }
        this.chart.setOption(options);
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
